import { useLocation, useParams } from "react-router-dom";

import ViewResources from "@swivu/shared-ui/src/components/ViewResources.js";

const ViewResourcesPublic = () => {
  const { id, slug } = useParams<{ id: string; slug: string }>();
  const { pathname } = useLocation();
  return (
    <ViewResources.Provider
      id={id!}
      api="public"
      slug={slug!}
      baseDetailUrl={`${pathname}/resource`}
    >
      <ViewResources />
    </ViewResources.Provider>
  );
};

export default ViewResourcesPublic;
